// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/img/ground_final.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/img/goal_final.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/img/Snaky-Gardien.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/img/ball.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*body{
    font-family: 'Raleway', sans-serif !important;
}*/

.custom-label {
    color: white !important; /* Changer la couleur du texte du label en blanc */
}

.custom-label.MuiInputLabel-outlined {
    color: black !important; /* Changer la couleur du label quand il est en dehors du champ pour la variante 'outlined' */
}

.custom-label.Mui-focused {
    color: black !important; /* Changer la couleur du label quand le champ est en focus */
    font-weight: bold;
}

.custom-underline::before,
.custom-underline::after {
    border-bottom: 2px solid black !important;
}

.custom-input {
    color: white !important; /* Changer la couleur du texte en blanc */
}


/*######################*/
.game-field {
    position: relative;
    width: 100%;
    min-height: 100vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    border: 1px solid #003300;
    border-radius: 10px;
}

.goal {
    position: absolute;
    top: 0;
    width: 100%;
    height: 25%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    border-radius: 10px;
}

.goalkeeper {
    position: absolute;
    top: 18px;
    width: 25%;
    height: 75%;
    /* background-color: #000000;*/
    border-radius: 20px;
    transition: left 40ms ease;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    background-position: center;
}

.ball {
    position: absolute;
    bottom: 5%; /* Ajustez selon la hauteur souhaitée du bas du terrain */
    left: 50%;
    transform: translateX(-50%);
    width: 45px;
    height: 45px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
    background-position: center;
    border-radius: 50%;
    cursor: pointer;
    transition: left 0.5s ease, bottom 0.4s ease; /* Ajout de transition pour le mouvement vertical */
}

.shoot-buttons {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
}

.shoot-buttons button {
    margin: 0 5px;
    padding: 5px 10px;
}

.scoreboard {
    border: 2px solid #0a0;
    padding: 5px;
    width: 60%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 110%;
    margin-left: auto;
    margin-right: auto;
    background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;IACI,uBAAuB,EAAE,kDAAkD;AAC/E;;AAEA;IACI,uBAAuB,EAAE,4FAA4F;AACzH;;AAEA;IACI,uBAAuB,EAAE,4DAA4D;IACrF,iBAAiB;AACrB;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB,EAAE,yCAAyC;AACtE;;;AAGA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,yDAAyD;IACzD,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,yDAAuD;IACvD,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;IAC1B,yDAA0D;IAC1D,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU,EAAE,yDAAyD;IACrE,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,yDAAiD;IACjD,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,4CAA4C,EAAE,mDAAmD;AACrG;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":["/*body{\n    font-family: 'Raleway', sans-serif !important;\n}*/\n\n.custom-label {\n    color: white !important; /* Changer la couleur du texte du label en blanc */\n}\n\n.custom-label.MuiInputLabel-outlined {\n    color: black !important; /* Changer la couleur du label quand il est en dehors du champ pour la variante 'outlined' */\n}\n\n.custom-label.Mui-focused {\n    color: black !important; /* Changer la couleur du label quand le champ est en focus */\n    font-weight: bold;\n}\n\n.custom-underline::before,\n.custom-underline::after {\n    border-bottom: 2px solid black !important;\n}\n\n.custom-input {\n    color: white !important; /* Changer la couleur du texte en blanc */\n}\n\n\n/*######################*/\n.game-field {\n    position: relative;\n    width: 100%;\n    min-height: 100vh;\n    background-image: url(\"/src/assets/img/ground_final.png\");\n    background-size: cover;\n    background-position: center;\n    border: 1px solid #003300;\n    border-radius: 10px;\n}\n\n.goal {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 25%;\n    background-image: url(\"/src/assets/img/goal_final.png\");\n    background-size: cover;\n    background-position: center;\n    border-radius: 10px;\n}\n\n.goalkeeper {\n    position: absolute;\n    top: 18px;\n    width: 25%;\n    height: 75%;\n    /* background-color: #000000;*/\n    border-radius: 20px;\n    transition: left 40ms ease;\n    background-image: url(\"/src/assets/img/Snaky-Gardien.png\");\n    background-size: cover;\n    background-position: center;\n}\n\n.ball {\n    position: absolute;\n    bottom: 5%; /* Ajustez selon la hauteur souhaitée du bas du terrain */\n    left: 50%;\n    transform: translateX(-50%);\n    width: 45px;\n    height: 45px;\n    background-image: url(\"/src/assets/img/ball.png\");\n    background-size: cover;\n    background-position: center;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: left 0.5s ease, bottom 0.4s ease; /* Ajout de transition pour le mouvement vertical */\n}\n\n.shoot-buttons {\n    position: absolute;\n    bottom: 10px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.shoot-buttons button {\n    margin: 0 5px;\n    padding: 5px 10px;\n}\n\n.scoreboard {\n    border: 2px solid #0a0;\n    padding: 5px;\n    width: 60%;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 110%;\n    margin-left: auto;\n    margin-right: auto;\n    background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
